module.exports = __webpack_public_path__ + "img/1-hondenspeelgoed.12f9203b.jpg";